import React from 'react';
import {
  Box,
  Button,
  Card,
  CardBody,
  CardHeader,
  Heading,
  Stack,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useUser } from '../../contexts/UserContext';

const TrialExpiredScreen = () => {
  const { t } = useTranslation();
  const { logout, user, trialAccess } = useUser();
  const bg = useColorModeValue('gray.50', 'gray.900');
  const cardBg = useColorModeValue('white', 'gray.800');
  const muted = useColorModeValue('gray.600', 'gray.300');

  return (
    <Box minH="100vh" bg={bg} px={4} py={{ base: 10, md: 20 }}>
      <Card maxW="xl" mx="auto" bg={cardBg} shadow="lg" borderRadius="xl">
        <CardHeader pb={2}>
          <Heading size="lg">{t('trial_access.expired.title')}</Heading>
        </CardHeader>
        <CardBody pt={2}>
          <Stack spacing={4}>
            <Text color={muted}>{t('trial_access.expired.description')}</Text>
            {user?.organization?.name ? (
              <Text color={muted}>
                {t('trial_access.expired.organization', { organization: user.organization.name })}
              </Text>
            ) : null}
            {trialAccess?.expiresAt ? (
              <Text color={muted}>
                {t('trial_access.expired.expired_on', { date: trialAccess.expiresAt })}
              </Text>
            ) : null}
            <Box>
              <Button onClick={logout} variant="outline">
                {t('trial_access.expired.logout')}
              </Button>
            </Box>
          </Stack>
        </CardBody>
      </Card>
    </Box>
  );
};

export default TrialExpiredScreen;
